import React, { useState } from "react";
import { Document, Page } from "react-pdf";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faExternalLinkAlt,
  faDownload,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";
function ConstanciapdfModal({ url, isOpen, handleClose }) {
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }
  function download(url, filename) {
    fetch(url)
      .then((response) => response.blob())
      .then((blob) => {
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = filename;
        link.click();
      })
      .catch(console.error);
  }
  return (
    <Modal isOpen={isOpen} className="viewPDFModal--autoria">
      <div className="container1">
        <div className="buttons">
          <a href={url} target="_blank">
            <FontAwesomeIcon icon={faExternalLinkAlt} className="follow" />
          </a>
          <FontAwesomeIcon
            icon={faDownload}
            className="download"
            onClick={() => download(url, "constanciaDigitalDeAutoria.pdf")}
          />
          <div className="close" onClick={handleClose}>
            <FontAwesomeIcon icon={faTimes} className="icon" />
          </div>
        </div>
        <Document file={url} options={{
            cMapUrl: `cmaps/`,
            cMapPacked: true,
            standardFontDataUrl: 'standard_fonts/',
        }} onLoadSuccess={onDocumentLoadSuccess}>
          <Page pageNumber={pageNumber} />
        </Document>
      </div>
    </Modal>
  );
}

export default ConstanciapdfModal;
